import { useEffect } from "react";
import { useTemplatesEditorSettings } from "../context/templates-editor-settings-context";

/**
 * Warn users when they try to leave the page with unsaved changes.
 *
 * This handles only browser-level navigation (refresh, tab close, external
 * links) via `beforeunload`, which is router-agnostic and works in every host.
 *
 * Blocking *internal* SPA navigation requires the host router and is therefore
 * handled by each dedicated editor wrapper (TemplatesEditor uses TanStack
 * Router's blocker; ReturnTemplatesEditor relies on beforeunload only because
 * baback-office runs on a declarative <BrowserRouter>).
 */
export function useUnsavedChanges(isDirty: boolean) {
  const { devMode } = useTemplatesEditorSettings();

  useEffect(() => {
    if (!isDirty || devMode) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty, devMode]);
}
